import { render, staticRenderFns } from "./DadosGerais.vue?vue&type=template&id=f9698e68"
import script from "./DadosGerais.vue?vue&type=script&lang=js"
export * from "./DadosGerais.vue?vue&type=script&lang=js"
import style0 from "./DadosGerais.vue?vue&type=style&index=0&id=f9698e68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports